import _ from 'lodash';
const MoneyBlockSiteGrp = 'mb';
const isMoneyBlockUrl = (siteGroup) => {
    return siteGroup === MoneyBlockSiteGrp;
};
const isMoneyBlockOrigin = (origin) => {
    return origin === MoneyBlockSiteGrp;
};
export const isMoneyBlockAccount = (accountNumber) => {
    // MoneyBlock account numbers start with "3OD"
    return _.take(accountNumber, 3).join('') === '3OD';
};
const isMoneyBlockSite = (siteGroup, accountNumber, origin) => {
    return isMoneyBlockUrl(siteGroup) || isMoneyBlockAccount(accountNumber) || isMoneyBlockOrigin(origin);
};
export const GetSiteName = (siteGroup, origin, accountNumber) => {
    if (isMoneyBlockSite(siteGroup, accountNumber, origin)) {
        return 'MoneyBlock';
    }
    return 'TradingBlock';
};
export const GetSiteGrp = (siteGroup, origin, accountNumber) => {
    if (isMoneyBlockSite(siteGroup, accountNumber, origin)) {
        return MoneyBlockSiteGrp;
    }
    return '';
};
export const getSiteLogo = (siteGroup, type, accountNumber) => {
    // for logo mark, site branding not needed
    if (type === 'mark') {
        return `logo-${type}`;
    }
    const logo = `logo-${GetSiteName(siteGroup, accountNumber).toLowerCase()}`;
    if (type) {
        return `${logo}-${type}`;
    }
    return logo;
};
//# sourceMappingURL=SiteUtilities.js.map